import React from 'react';
import { Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import s from './VideoReview.module.scss';
import { Title } from '../Home/Title';
import dynamic from 'next/dynamic';

const VideoCard = dynamic(
  () => import('../cards/VideoCard'),
  {
    ssr: false,
  }
);


export const VideoReview = ({ data, showTextShadowHeading = false }) => (
  <div className={s.root}>
    {showTextShadowHeading ? (
      <div className={s.shadowTitle}>
        <Title
          bgTitle="VIDEOS REVIEW"
          title="Behind the wheel in-depth video review of the car"
        />
      </div>
    ) : (
      <Typography
        label="Video review"
        renderAs="H2"
        variant={TypeScales.h2}
        className={s.title}
      />
    )}
    <div className={s.card_container}>
      {data
        ?.filter((obj, idx) => idx < 3)
        ?.map((obj) => (
          <div className={s.card} key={obj?.videLink}>
            <VideoCard url={obj?.videoLink} description={obj.description} />
          </div>
        ))}
    </div>
  </div>
);
